import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgPaymentSavings(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M74.007 42.617a2 2 0 0 1 .805-1.603l7.825-5.83c.3-.223.653-.38 1.016-.47.2-.05.388-.096.443-.098.002 0 .004.002.004.004v9.772a2 2 0 0 1-2 2h-6.093a2 2 0 0 1-2-2v-1.775Zm0-5.759v1.873-1.873Z"
        fill="#599F40"
      />
      <path
        d="M75.606 44.392c0 .22.18.4.4.4H82.1a.4.4 0 0 0 .4-.4v-7.11l-6.732 5.015a.4.4 0 0 0-.162.32v1.775Zm-1.6-1.775.014-.234a2 2 0 0 1 .793-1.37l7.824-5.828.115-.082c.273-.18.584-.31.901-.39.2-.049.388-.095.443-.097.002 0 .004.002.004.004v9.772a2 2 0 0 1-2 2h-6.093l-.204-.011a2 2 0 0 1-1.796-1.99v-1.774Z"
        fill="#0F172A"
      />
      <path
        d="M75.188 87.114a.5.5 0 0 1 .499.5h1.024a1 1 0 0 1 1 1v.356C77.691 92.597 73 99.5 67.395 99.838a.93.93 0 0 1-.357-.345 2.367 2.367 0 0 1-.199-.412 7.88 7.88 0 0 1-.314-1.13c-.19-.888-.35-2.053-.456-3.302-.211-2.479-.219-5.388.223-7.155l.028-.08a.5.5 0 0 1 .458-.299h8.41Z"
        fill="#599F40"
      />
      <path
        d="M76.911 88.614a.2.2 0 0 0-.2-.2h-1.024a.8.8 0 0 1-.742-.5h-7.928c-.355 1.655-.352 4.312-.152 6.667.105 1.227.261 2.358.442 3.202.09.423.185.765.28 1.01.033.088.067.158.097.214 2.373-.27 4.63-1.847 6.352-3.886 1.813-2.147 2.864-4.6 2.875-6.15v-.357Zm1.6.361c-.012 2.077-1.316 4.885-3.252 7.178-1.948 2.307-4.708 4.296-7.817 4.482a.79.79 0 0 1-.405-.083 1.72 1.72 0 0 1-.675-.632 3.167 3.167 0 0 1-.27-.553 8.659 8.659 0 0 1-.35-1.25c-.199-.93-.362-2.132-.47-3.401-.213-2.493-.232-5.514.244-7.417l.02-.065.027-.08a1.3 1.3 0 0 1 1.215-.84h8.41c.404 0 .778.189 1.022.5h.501a1.8 1.8 0 0 1 1.8 1.8v.361Z"
        fill="#0F172A"
      />
      <path
        d="M46.223 87.114a.5.5 0 0 0-.499.5H44.7a1 1 0 0 0-1 1v.356c.02 3.627 4.8 10.03 10.316 10.867a.93.93 0 0 0 .357-.345 2.36 2.36 0 0 0 .199-.412c.115-.3.22-.688.314-1.13.19-.888.35-2.053.457-3.302.21-2.479.218-5.388-.224-7.155l-.027-.08a.5.5 0 0 0-.458-.299h-8.41Z"
        fill="#599F40"
      />
      <path
        d="M44.5 88.614c0-.11.09-.2.2-.2h1.025a.8.8 0 0 0 .74-.5h7.93c.355 1.655.351 4.312.151 6.667-.105 1.227-.26 2.358-.441 3.202a7.11 7.11 0 0 1-.28 1.01 2.094 2.094 0 0 1-.079.18c-2.366-.485-4.628-2.083-6.346-4.05-1.83-2.091-2.89-4.416-2.9-5.953v-.356Zm-1.6.361c.013 2.09 1.352 4.778 3.295 7.001 1.961 2.243 4.692 4.195 7.702 4.652a.804.804 0 0 0 .477-.076 1.72 1.72 0 0 0 .675-.632 3.16 3.16 0 0 0 .27-.553c.137-.356.252-.79.35-1.25.199-.93.363-2.132.47-3.401.213-2.493.232-5.514-.243-7.417l-.02-.065-.027-.08a1.3 1.3 0 0 0-1.215-.84h-8.41c-.404 0-.78.189-1.023.5h-.5a1.8 1.8 0 0 0-1.8 1.8v.361Z"
        fill="#0F172A"
      />
      <path
        d="M77.37 32.938v6.134c0 .987.723 1.819 1.687 2.036C87.846 43.086 94.869 49.73 97.39 58.3c.264.898 1.066 1.55 2.002 1.55h1.892a3 3 0 0 1 3 3v5.776a3 3 0 0 1-3 3H99.13c-.909 0-1.696.618-1.981 1.48A24.889 24.889 0 0 1 84.12 87.79c-.004.363-.016.682-.016.819v3.332c0 .471-.222.916-.599 1.2l-8.302 6.24a1.92 1.92 0 0 1-.69.32l-.523.13-.142.032a1.037 1.037 0 0 1-.154.021h-.02a.678.678 0 0 1-.092-.007.5.5 0 0 1-.295-.045.93.93 0 0 1-.356-.345 2.36 2.36 0 0 1-.2-.412c-.114-.3-.22-.689-.314-1.13-.19-.888-.35-2.054-.456-3.302-.124-1.461-.177-3.072-.11-4.51H49.588c.067 1.438.015 3.049-.11 4.51-.105 1.248-.266 2.414-.455 3.302-.095.441-.2.83-.315 1.13-.057.149-.123.291-.199.412a.93.93 0 0 1-.355.345.499.499 0 0 1-.295.045.68.68 0 0 1-.091.007h-.02c-.06-.002-.122-.015-.154-.021a4.323 4.323 0 0 1-.142-.031l-.333-.083-.191-.048a1.92 1.92 0 0 1-.69-.32l-8.302-6.242a1.501 1.501 0 0 1-.599-1.198v-3.332c0-.105-.02-.304-.049-.589a28.482 28.482 0 0 1-.048-.51c-8.125-4.077-13.702-12.482-13.703-22.191 0-13.704 11.11-24.813 24.814-24.814h17.965c.447 0 .882-.15 1.234-.426l8.345-6.547a2.82 2.82 0 0 1 1.055-.506 3.88 3.88 0 0 1 .416-.09c.003 0 .004 0 .004.003Z"
        fill="#78B441"
      />
      <path
        d="M18.428 52.46a.8.8 0 1 0 .916-1.311 4.248 4.248 0 0 1 4.862-6.966.8.8 0 0 0 .916-1.312 5.847 5.847 0 1 0-6.694 9.59Z"
        fill="#0F172A"
      />
      <path
        d="M20.176 50.066a.8.8 0 1 1 .915-1.312 2.78 2.78 0 0 0 3.182-4.558.8.8 0 1 1 .916-1.312 4.38 4.38 0 0 1-5.013 7.182Z"
        fill="#0F172A"
      />
      <path
        d="M21.232 49.942a.801.801 0 0 0-.067-1.13c-1.015-.903-.954-1.735-.713-2.155.253-.441.819-.698 1.497-.329a.8.8 0 0 0 .765-1.406c-1.446-.788-2.967-.252-3.65.939-.695 1.211-.42 2.851 1.038 4.148a.8.8 0 0 0 1.13-.067ZM18.429 52.46c2.98 2.081 7.083 1.361 9.16-1.615a.8.8 0 1 0-1.311-.916c-1.57 2.248-4.673 2.798-6.934 1.22a.8.8 0 1 0-.915 1.312Z"
        fill="#0F172A"
      />
      <path
        d="M52.024 41.49c1.104 4.118 4.78 6.71 8.21 5.79l-2.485.667c-3.43.919-7.106-1.673-8.21-5.79-1.103-4.118.784-8.2 4.215-9.12l2.485-.666c-3.43.92-5.318 5.002-4.215 9.12Z"
        fill="#E67500"
      />
      <path
        d="M64.45 38.161c1.102 4.117-.785 8.2-4.216 9.12-3.43.919-7.106-1.673-8.21-5.79-1.103-4.118.784-8.2 4.215-9.12 3.431-.92 7.107 1.673 8.21 5.79ZM54.861 16.832c-3.428 3.429-4.817 7.597-3.103 9.311 1.714 1.715 5.883.325 9.31-3.103 3.429-3.428 4.819-7.597 3.104-9.311-1.714-1.714-5.882-.325-9.31 3.103Z"
        fill="#FC0"
      />
      <path
        d="M61.069 23.04c-3.428 3.428-7.597 4.817-9.311 3.103l2.069 2.07c1.714 1.713 5.883.324 9.31-3.104 3.43-3.429 4.819-7.597 3.105-9.311l-2.07-2.07c1.715 1.715.325 5.883-3.103 9.312Z"
        fill="#E67500"
      />
      <path d="M46.43 45.163h22.24v5.56H46.43v-5.56Z" fill="#78B441" />
      <path
        d="M47.314 44.5c0-.465.376-.842.84-.842H65.82a.841.841 0 1 1 0 1.682H48.155a.841.841 0 0 1-.841-.84ZM96.688 72.943a4.692 4.692 0 0 1-3.317-5.746.8.8 0 1 1 1.545.414 3.092 3.092 0 0 0 2.186 3.787.8.8 0 1 1-.414 1.545ZM86.202 52.28c1.071 0 1.954.801 2.084 1.838l-1.911 1.092-.76.435.76.433 1.93 1.103v.566a2.102 2.102 0 1 1-4.206 0v-3.365c0-1.161.942-2.102 2.103-2.102ZM57.994 54.828V52.28a1.1 1.1 0 1 1 2.2 0v2.548a1.1 1.1 0 1 1-2.2 0ZM57.994 82.36v-2.55a1.1 1.1 0 1 1 2.2 0v2.55a1.1 1.1 0 1 1-2.2 0Z"
        fill="#0F172A"
      />
      <path
        d="M51.877 73.693a1.1 1.1 0 1 1 2.2 0 5.018 5.018 0 0 0 10.034 0 1.1 1.1 0 0 1 2.2 0 7.218 7.218 0 0 1-14.434 0ZM52.386 60.947a1.1 1.1 0 1 0 2.199 0 5.018 5.018 0 0 1 10.035 0 1.1 1.1 0 0 0 2.2 0 7.218 7.218 0 0 0-14.434 0Z"
        fill="#0F172A"
      />
      <path
        d="M54.587 60.947a1.1 1.1 0 0 0-2.2 0c0 1.865.49 3.787 1.675 5.267 1.213 1.517 3.07 2.46 5.543 2.46a1.1 1.1 0 0 0 0-2.2c-1.86 0-3.063-.681-3.825-1.634-.791-.988-1.193-2.38-1.193-3.893Z"
        fill="#0F172A"
      />
      <path
        d="M64.111 73.693a1.1 1.1 0 1 0 2.2 0 7.218 7.218 0 0 0-7.217-7.218 1.1 1.1 0 0 0 0 2.2 5.018 5.018 0 0 1 5.017 5.018Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgPaymentSavings)
